import React from "react";

const SectionHeader = ({ title, children }) => (
  <div className="acc-section-header">
    <h2 className="acc-section-title">{title}</h2>

    {children && <div className="acc-section-aside">{children}</div>}
  </div>
);

export default SectionHeader;
